import type {
  EstimateRequestCreateDto,
  EstimateRequestCustomerInformationFormValues,
  EstimateRequestDamageCreateDto,
  EstimateRequestDamageInformationFormValues,
  EstimateRequestVehicleInformationFormValues,
} from "features/EstimateRequest/entities";

export function mapEstimateRequestFormValuesToEstimateRequestCreateDto({
  customerInformation,
  vehicleInformation,
  damageInformation,
  recaptchaToken,
  locale,
}: {
  customerInformation: EstimateRequestCustomerInformationFormValues;
  vehicleInformation: EstimateRequestVehicleInformationFormValues;
  damageInformation: EstimateRequestDamageInformationFormValues;
  recaptchaToken: string;
  locale: string;
}): EstimateRequestCreateDto {
  const vehicleYear = vehicleInformation.vehicleYear?.getFullYear();
  if (!vehicleYear) {
    throw new Error("Vehicle year is required");
  }

  const damages: EstimateRequestDamageCreateDto[] =
    damageInformation.damageLocations
      .flatMap((location) => [
        { fileId: location.images[0].fileId, location: location.location },
        { fileId: location.images[1].fileId, location: location.location },
      ])
      .filter(
        (entry): entry is EstimateRequestDamageCreateDto =>
          entry.fileId !== null && entry.location !== "DefaultInvalid"
      );
  for (const otherImage of damageInformation.otherImages) {
    if (!otherImage.fileId) {
      continue;
    }
    damages.push({
      fileId: otherImage.fileId,
      location: "Other",
    });
  }
  return {
    firstName: customerInformation.firstName,
    lastName: customerInformation.lastName,
    email: customerInformation.email,
    phoneNumber: customerInformation.phoneNumber,
    vehicleMake: vehicleInformation.vehicleMake,
    vehicleModel: vehicleInformation.vehicleModel,
    vinNumber: vehicleInformation.vinNumber.toUpperCase(),
    vehicleYear,
    notes: customerInformation.notes,
    shopId: customerInformation.shopId,
    vinFileId: vehicleInformation.vinFileId || undefined,
    paymentMethod: vehicleInformation.paymentType,
    insurerId:
      vehicleInformation.paymentType === "InsurerPay"
        ? vehicleInformation.insurerId
        : undefined,
    damages,
    gRecaptchaResponse: recaptchaToken,
    locale,
  };
}
